import * as React from "react";
const SVGComponent = ({
  color = "black",
  height = 24,
  width = 24,
  ...props
}: any) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4881_131028)">
      <path
        d="M16.415 14H21.2998C21.4869 14 21.6342 14.0513 21.7197 14.1084C21.7643 14.1382 21.7807 14.1603 21.7861 14.1699V14.8301C21.7807 14.8397 21.7643 14.8618 21.7197 14.8916C21.6342 14.9487 21.4869 15 21.2998 15H16.415C16.228 15 16.0806 14.9487 15.9951 14.8916C15.9506 14.8619 15.9342 14.8398 15.9287 14.8301V14.1699C15.9342 14.1602 15.9506 14.1381 15.9951 14.1084C16.0806 14.0513 16.228 14 16.415 14Z"
        fill={color}
        stroke={color}
      />
      <path
        d="M7.58557 18.8569H2.70029C2.15577 18.8569 1.71436 19.3627 1.71436 19.9866V21.1558C1.71436 21.7797 2.15577 22.2855 2.70029 22.2855H7.58557C8.13008 22.2855 8.5715 21.7797 8.5715 21.1558V19.9866C8.5715 19.3627 8.13008 18.8569 7.58557 18.8569Z"
        fill={color}
      />
      <path
        d="M23.0143 18.8569H18.129C17.5845 18.8569 17.1431 19.3627 17.1431 19.9866V21.1558C17.1431 21.7797 17.5845 22.2855 18.129 22.2855H23.0143C23.5588 22.2855 24.0002 21.7797 24.0002 21.1558V19.9866C24.0002 19.3627 23.5588 18.8569 23.0143 18.8569Z"
        fill={color}
      />
      <path
        d="M12.2056 10.8574H17.1427V5.14307"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.71436 13.7142C1.71442 12.019 2.1488 10.3618 2.96255 8.95232C3.77631 7.54281 4.9329 6.44424 6.28607 5.79552C7.63925 5.14679 9.12823 4.97705 10.5648 5.30775C12.0013 5.63845 13.3208 6.45474 14.3565 7.65341L17.1429 10.857"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs></defs>
  </svg>
);
export default SVGComponent;
